import React, { useRef, useEffect, useState } from "react";

import { PREVIEW_2_URL } from "utils/constants";

export default function InlinePRVW({
	creativeProps = [],
	libraryId = -1,
}){
	let src = `${PREVIEW_2_URL}/inline.html`
		, inlineRef = useRef()
		, [isReady, setIsReady] = useState(false)
		;

	useEffect(() => {
		if(!inlineRef.current){ return; }


		function onLoad(){
			console.log("Set!");
			setIsReady(true);
		}

		let inlineFrame = inlineRef.current;

		inlineFrame.addEventListener("load", onLoad);

		return () => {
			inlineFrame.removeEventListener("load", onLoad);
		};
	}, []);

	useEffect(() => {
		if(!isReady){ return; }


		let displayData = creativeProps.map((creative, index) => {
			let clickTags = [];

			for (let i = 0; i < creative.numClickTags; i++) {
				clickTags.push(`${PREVIEW_2_URL}/clicktag/?count=${creative.numClickTags}&current=${i+1}`);
			}

			let versionInfo = {};

			Object.entries(creative.version).forEach(([key, value]) => {
				// AdStudio previews don't like string values - `formattedTextVariable:"something"`
				// Strip them out before sending to AdStudio
				if(typeof(value) === "object"){
					versionInfo[key] = value;
				}
			});

			return {
				landingPageRedirects:clickTags,
				creative: {
					adType: creative.adType,
					creativeLibrary: {
						id: libraryId,
					},
					height: creative.height,
					width: creative.width,

					...creative,
					version:versionInfo,
				},
				placement: {
					id: `${creative.id}${index}`,
				},
			};
		});


		inlineRef?.current?.contentWindow.postMessage({
			type:"displayUpdate",
			creatives:displayData,
		}, PREVIEW_2_URL);
	}, [isReady, creativeProps]);

	return (
		<iframe
			ref={inlineRef}
			className="creative-preview-frame"
			src={src}
			allowFullScreen
		/>
	);
}
